import { PaymentRequestBalanceDto } from "@inosio/payments-sdk";
import { Box, Button, Dialog, DialogContent, Divider, Grid, Typography, useMediaQuery } from "@mui/material";
import NumberFormat from "react-number-format";
import WhiteInosio from "../../../icons/whiteinosio.svg";
import { convertCentsToDollars } from "../../util/converters";

interface PayDetailModalProps {
    open: boolean;
    PaymentRequestDetails: PaymentRequestBalanceDto | null;
    onContinue: () => void;
}
const PayDetailsModal = (props: PayDetailModalProps) => {
    const { PaymentRequestDetails, open, onContinue } = props
    const isOnMobileScreen = useMediaQuery("(max-width:600px)");
    const style = {
        height: isOnMobileScreen ? "100%" : "523px",
    };
    return (
        <Dialog
            open={open}
            fullScreen={isOnMobileScreen}
            BackdropProps={{
                invisible: true,
            }}
            fullWidth={true}
            disableEnforceFocus
            style={{
                background: "none",
            }}
            PaperProps={{
                style: {
                    pointerEvents: "auto",
                    borderRadius: isOnMobileScreen ? "0px" : "24px",
                    width: isOnMobileScreen ? "100%" : "472px",
                    boxShadow: "none",
                    overflow: "hidden"
                },
            }}
            disableEscapeKeyDown={true}
        >
            <DialogContent>
                <Box sx={style}>
                    <Grid item display='flex' justifyContent='space-between' flexDirection='column' sx={{ height: '100%' }} >
                        <Grid item display="flex" flexDirection="column">
                            {isOnMobileScreen ?
                                <Grid item display='flex' justifyContent='center'>
                                    <Grid item display='flex' pl={4} sx={{ width: '340px' }}>
                                        <img src={WhiteInosio} style={{ width: "75px", height: "75px" }} alt="logo" />
                                        <Typography
                                            sx={{
                                                fontFamily: "Work Sans",
                                                fontStyle: 'normal',
                                                fontWeight: 700,
                                                fontSize: '18px',
                                                lineHeight: '23px',
                                                color: '#14142B',
                                                textAlign: 'left',
                                                padding: '15px'
                                            }}>
                                            {PaymentRequestDetails?.CompanyName}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                : <></>}
                            <Typography id='paymentReq' sx={{
                                fontFamily: "Work Sans",
                                fontStyle: 'normal',
                                fontWeight: 700,
                                fontSize: '18px',
                                lineHeight: '23px',
                                color: '#14142B',
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '30px'
                            }}>
                                Payment Request
                            </Typography>
                            <Typography sx={{
                                fontFamily: "Work Sans",
                                fontStyle: 'normal',
                                fontWeight: 400,
                                fontSize: '16px',
                                lineHeight: '23px',
                                color: '#14142B',
                                textAlign: 'justify',
                                marginTop: '10px'
                            }}>
                                {`${PaymentRequestDetails?.CompanyName ? PaymentRequestDetails?.CompanyName : ''} has requested the following payment from you.
                             Please complete the check out process to submit this payment. 
                             If you have any questions please contact the Property Manager.`}
                            </Typography>
                            <Grid item xs={12} mt={2} sx={{
                                maxHeight: "240px",
                                overflow: 'auto',
                                "&::-webkit-scrollbar": {
                                    width: 7,
                                },
                                "&::-webkit-scrollbar-track": {
                                    boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
                                    borderRadius: '24px',
                                },
                                "&::-webkit-scrollbar-thumb": {
                                    backgroundColor: "darkgrey",
                                    borderRadius: '24px',
                                }
                            }}>
                                {
                                    PaymentRequestDetails?.RequestDetails?.map((req, index, row) => {
                                        return (
                                            <Grid item xs={12} key={index}>
                                                <Grid item xs={12} display='flex' justifyContent={'space-between'} ml={1} mr={2}>
                                                    <Grid item xs={9.5}>
                                                        <Typography
                                                            sx={{
                                                                fontWeight: 600,
                                                                fontSize: "16px",
                                                                lineHeight: "22px",
                                                                fontFamily: "Work Sans",
                                                                // color: '#D3D3D3'
                                                            }}>
                                                            {req.Description}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Typography
                                                            sx={{
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "22px",
                                                                fontFamily: "Work Sans",
                                                                // color: '#D3D3D3'
                                                            }}>
                                                            <NumberFormat
                                                                thousandsGroupStyle="thousand"
                                                                value={convertCentsToDollars(req.Amount)}
                                                                prefix="$"
                                                                decimalSeparator="."
                                                                displayType="text"
                                                                type="text"
                                                                thousandSeparator={true}
                                                                allowNegative={true}
                                                                decimalScale={2}
                                                                fixedDecimalScale={true}
                                                            />
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} mt={1} mb={1} mr={1}>
                                                    {index+1 === row.length ? '' : <Divider sx={{ width: '100%' }} />}
                                                </Grid>
                                            </Grid>
                                        )
                                    })
                                }
                            </Grid>
                            <Grid item sx={{ position: 'relative', width: '100%' }} >
                                <Divider />
                                <Grid container justifyContent={'space-between'}>
                                    <Grid item pt={2}>
                                        <Typography
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: "18px",
                                                lineHeight: "22px",
                                                fontFamily: "Work Sans",
                                            }}>
                                            Total
                                        </Typography>
                                    </Grid>
                                    <Grid item pt={2}>
                                        <Typography
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: "18px",
                                                lineHeight: "22px",
                                                fontFamily: "Work Sans",
                                            }}>
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={convertCentsToDollars(PaymentRequestDetails?.Amount ? PaymentRequestDetails?.Amount : 0)}
                                                prefix="$"
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                allowNegative={true}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                            />
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid mt={3} item display={'flex'} flexDirection={isOnMobileScreen ? 'column' : 'row'} justifyContent={'flex-end'}>
                            <Grid item xs={12}>
                                <Button id='onConfirmBtn'
                                    variant="contained"
                                    style={{
                                        borderRadius: "24px",
                                        textTransform: "capitalize",
                                        color: "white",
                                        backgroundColor: "#39A2DB",
                                        borderColor: "#39A2DB",
                                        height: '49',
                                        width: isOnMobileScreen ? '100%' : '140px',
                                        marginBottom: isOnMobileScreen ? 20 : 0
                                    }}
                                    onClick={() => {
                                        onContinue()
                                    }}
                                >
                                    continue
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>

                </Box>
            </DialogContent>
        </Dialog>
    );
}

export default PayDetailsModal;
